import { DefaultOptionType } from "antd-v5/es/select";

interface AccountItem {
  accountAbbr: string;
  accountId: number;
}

interface GenericItem {
  name: string;
  id: any;
}
export default function TopFilterBase() {
  const handleOptionList = (
    list: AccountItem[] | GenericItem[],
    isAccountAbbr: boolean,
    isProcessStatus?: boolean
  ) => {
    const tempOptionList = list.map((item) =>
      isAccountAbbr
        ? { name: (item as AccountItem).accountAbbr, value: (item as AccountItem).accountId }
        : { name: (item as GenericItem).name, value: (item as GenericItem).id }
    );

    return isProcessStatus ? tempOptionList : tempOptionList.sort(sortList);
  };

  /* function about sort filter list by alphabetical order */
  const sortList = (s: any, t: any) => {
    const a = (s.name || "").toLowerCase();
    const b = (t.name || "").toLowerCase();
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  };

  const sortListV5 = (s: DefaultOptionType, t: DefaultOptionType) => {
    const a = (s.label || "").toString().toLowerCase();
    const b = (t.label || "").toString().toLowerCase();
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  };

  /* function about sort MyRequest Process Status list by id order */
  const sortProcessStatusList = (s: any, t: any) => {
    const isByIndex = typeof s.index === "number";
    const a = isByIndex ? s.index : s.value;
    const b = isByIndex ? t.index : t.value;
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  };

  /**
   * function about when select option the filter options will move the selected options top
   * @param {*} optionList
   * @param {*} selectList
   * @returns
   */
  const handleChange = (optionList: any, selectList: any, isProcessStatus = false) => {
    const selectOptionList: any[] = [];
    if (Array.isArray(selectList)) {
      selectList.forEach((selectItem) => {
        optionList.map((OptionItem: any, optionIndex: any) => {
          if (OptionItem.value === selectItem) {
            const item = optionList.splice(optionIndex, 1);
            selectOptionList.push(item[0]);
          }
        });
      });
    } else {
      optionList.forEach((OptionItem: any, optionIndex: any) => {
        if (OptionItem.value === selectList) {
          const item = optionList.splice(optionIndex, 1);
          selectOptionList.push(item[0]);
        }
      });
    }

    if (isProcessStatus) {
      return selectOptionList.sort((s, t) => sortProcessStatusList(s, t));
    }
    return selectOptionList.sort((s, t) => sortList(s, t));
  };

  /**
   * function about delete seleced option
   * @param {*} value: delete item's value
   * @param {*} optionList: current select options
   */
  const handleDeSelect = (value: any, selectList: any) => {
    const i = selectList.findIndex((item: any) => item === value);
    i !== -1 && selectList.splice(i, 1);
    return selectList;
  };

  /**
   * function about select filter option
   * @param {*} value input enter value
   * @param {*} optionList current filter all options
   */
  const handleFilterOption = (input: any, option: any) =>
    (option?.title ?? "").toLowerCase().includes(input.toLowerCase());

  const handleFilterOptionV5 = (input: any, option: any) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return {
    handleOptionList,
    sortList,
    sortListV5,
    handleChange,
    handleDeSelect,
    handleFilterOption,
    handleFilterOptionV5,
    sortProcessStatusList,
  };
}
